import pathLib from "path-browserify-esm";

const dblAsterisks = "**";

export function shouldExclude(
  excludedPatterns: string[],
  path: string
): boolean {
  return excludedPatterns.some((pattern) => match(pattern, path));
}

function match(originalPattern: string, originalValue: string): boolean {
  if (originalPattern === "") {
    return false;
  }

  const trimmedPattern = originalPattern.replace(/\s+$/, "");

  const negate = trimmedPattern.startsWith("!");
  const pattern = negate ? trimmedPattern.slice(1) : trimmedPattern;

  const cleanPattern = pattern.replace(/[/\\]$/, "");

  if (cleanPattern.includes(dblAsterisks)) {
    const result = evalDblAsterisk(cleanPattern, originalValue);
    return negate ? !result : result;
  }

  if (matchFolder(cleanPattern, originalValue)) {
    return true;
  }

  const value = cleanPattern.includes(pathLib.sep)
    ? originalValue
    : pathLib.basename(originalValue);

  const matched = simpleMatch(cleanPattern, value);
  return negate ? !matched : matched;
}

function evalDblAsterisk(pattern: string, value: string): boolean {
  if (pattern.startsWith(dblAsterisks)) {
    const remainingPattern = pattern.slice(dblAsterisks.length);
    return value.endsWith(remainingPattern);
  }

  if (pattern.endsWith(dblAsterisks)) {
    const leadingPattern = pattern.slice(0, -dblAsterisks.length);
    return value.startsWith(leadingPattern);
  }

  const parts = pattern.split(dblAsterisks);
  let remainingValue = value;
  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i];
    switch (i) {
      case 0:
        if (!remainingValue.startsWith(part)) {
          return false;
        }
        break;
      case parts.length - 1: {
        const trimmedPart = part.replace(/^[/\\]/, "");
        return remainingValue.endsWith(trimmedPart);
      }
      default:
        if (!remainingValue.includes(part)) {
          return false;
        }
    }

    const index = remainingValue.indexOf(part) + part.length;
    remainingValue = remainingValue.slice(index);
  }

  return false;
}

function matchFolder(pattern: string, value: string): boolean {
  let currentValue = value;
  while (currentValue) {
    if (!currentValue.includes(pathLib.sep)) {
      return false;
    }
    currentValue = pathLib.dirname(currentValue);
    if (simpleMatch(pattern, currentValue)) {
      return true;
    }
  }

  return false;
}

function simpleMatch(pattern: string, value: string): boolean {
  const escapedPattern = pattern.replace(/[.+^${}()|[\]\\]/g, "\\$&");
  const wildcardPattern = escapedPattern
    .replace(/\*/g, ".*")
    .replace(/\?/g, ".");
  const regex = new RegExp(`^${wildcardPattern}$`);
  return regex.test(value);
}
